import { getFetcherWithToken } from 'src/utils/Fetcher';
import { getAudioUrl, getImageUrl } from 'src/utils/cdn';
import { getMediaUri } from 'src/utils/media';
import { withAudioOnly } from 'src/apis/questions';

// sample - CDN URLs
const questionsMock = [
  {
    audio: getAudioUrl('sample.mp3'),
    eng: 'alone',
    kor: '혼자, 외로운',
    image: getImageUrl('common/alone_sample.jpg'),
  },
  {
    audio: getAudioUrl('doll.mp3'),
    eng: 'doll',
    kor: '인형',
    image: getImageUrl('common/sample_doll.jpg'),
  },
  {
    audio: getAudioUrl('before.mp3'),
    eng: 'before',
    kor: '전에, 하기 전에',
    image: getImageUrl('common/sample_before.jpg'),
  },
];

function getAudioQuestions(payload) {
  return (token) =>
    getFetcherWithToken(token)
      .get(`/question?module_id=${payload.moduleId}`)
      .then((res) => {
        return {
          learningModule: res.data.ss_learning_module,
          questions: withAudioOnly(res.data.ss_questions).map((item) => {
            return {
              ...item,
              audio: new Audio(getMediaUri(item.audio.path)),
              image: item.image?.path ? getMediaUri(item.image.path) : '',
            };
          }),
        };
      });
}

export default {
  getAudioQuestions,
};
